import moment from "moment";
import { axiosGet, axiosPost } from "../../react_axios/Axios";
import { SEND_PAYMENT_FORM, sendPaymentFormUrl, headers } from "../../utils/constants";

export const sendPaymentForm_action = (award_event_profile_id, application_form_id, amount, currency, proformaList, from, applicationNo) => async (dispatch) => {
    try {
        const params = {
            UserID: sessionStorage.getItem("user_id"),
            award_event_id: sessionStorage.getItem("award_event_id"),
            award_event_profile_id: award_event_profile_id,
            application_form_id: application_form_id,
            amount: amount,
            currency: currency,
            proformaList: proformaList,
            from: from,
            applicationNo: applicationNo
        }
        const res = await axiosPost(sendPaymentFormUrl, params, headers);
        dispatch({
            type: SEND_PAYMENT_FORM,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};  